import { render } from "./AboutDetail.vue?vue&type=template&id=8aec3168&scoped=true"
import script from "./AboutDetail.vue?vue&type=script&lang=js"
export * from "./AboutDetail.vue?vue&type=script&lang=js"

import "./AboutDetail.vue?vue&type=style&index=0&id=8aec3168&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aec3168"]])

export default __exports__